module.exports = __webpack_public_path__ + "img/454849841_843369917861160_1174249647267941424_n.6413696e.jpg";